<template>
    <div>
        <v-row class="mt-3 ml-3">
            <v-btn
                size="small"
                color="primary"
                prepend-icon="mdi-arrow-left-bold"
                @click="$router.push('/AdminPanel')"
                >
                Powrót do panelu
            </v-btn>
        </v-row>
        <v-row class="ma-16">
          <v-col cols="12">
            <v-row>
                <v-col cols="12">
                    <v-card
                        v-for="(item, i) in getDuvets"
                        :key="i"
                        variant="outlined"
                        class="pa-3 ma-2"
                    >  
                        <v-row align="center">
                            <v-col cols="2" class="text-h6 text-primary text-center"> {{ item.size }} </v-col>
                            <v-col cols="3" class="text-h6 text-weight-light"> {{ item.thickness }} </v-col>
                            <v-col cols="7" class="text-h6 text-end"> Na stanie: {{ checkStorageStatus(item.id) }} </v-col>
                        </v-row>
                    </v-card>

                    <v-divider class="border-opacity-75 my-10"></v-divider>
                    <v-row>
                        <v-col cols="4">
                            <v-select label="Rozmiar" density="comfortable" :items="size" v-model="sizeval" variant="outlined"></v-select>
                        </v-col>
                        <v-col cols="4">
                            <v-select label="Grubość" density="comfortable" :items="thickness" v-model="thickval" variant="outlined"></v-select>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                            v-model="item_status"
                            label="Stan magazynowy"
                            density="comfortable"
                            type="number"
                            variant="outlined"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-btn append-icon="mdi-send" color="primary" @click="UpdateStorageStatus()">Zaktualizuj</v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
          </v-col>
        </v-row>
        

        <v-snackbar
        v-model="msgSnackbar"
        color="secondary"
        >
        Zaktualizowano!
        <template v-slot:actions>
            <v-btn
            icon="mdi-close"
            color="red"
            @click="msgSnackbar = false"
            >            
            </v-btn>
        </template>
        </v-snackbar>
    </div>
</template>

<script>
    import axios from 'axios'
    import { mapGetters } from 'vuex';

    export default {
        data () {
        return {
            storageDB: [],
            msgSnackbar: false,
            size: [],
            thickness: [],
            sizeval: '',
            thickval: '',
            item_status: 0,
        }
        },
        beforeCreate () {
            axios
            .get(`${process.env.VUE_APP_API}/storage_status`)
            .then((resp) => {
                this.storageDB = resp.data;
            });
        },
        created() {
            if(this.isLoggedIn !== true){
                this.$router.push('/AdminLogin')
            }
        },
        mounted () {
            this.size = this.$store.getters.getDuvetsSizes;
            this.thickness = this.$store.getters.getDuvetsThickness;
        },
        computed: {
            ...mapGetters([
                'getDuvets',
                'isLoggedIn',
            ]),
        },
        methods: {
            UpdateStorageStatus() {
                if(this.thickval !== null && this.sizeval !== null && this.item_status !== null) {
                    var prod_id = this.$store.getters.getDuvetID(this.sizeval, this.thickval)[0]

                    axios
                    .put(`${process.env.VUE_APP_API}/storage_update`, {'idvuex': prod_id, 'item_status': this.item_status}, {
                        headers: { 'Content-Type': 'application/json' }
                    })

                    this.msgSnackbar = true;

                    setTimeout( () => location.reload(), 4000);
                }
            },
            checkStorageStatus(id) {
                for(let i = 0; i < this.storageDB.length; i++) {
                    if(id === this.storageDB[i].id_vuex) {
                        return this.storageDB[i].item_count;
                    }
                }
                return null;
            }
        }
    }
</script>